import React from 'react';
import { IconProps } from '.';

const SvgEmail = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M1 21V3h22v18H1ZM2.5 4.5h19v2.925l-9.5 5.7-9.5-5.7V4.5Zm0 4.675V19.5h19V9.175l-9.114 5.468a.75.75 0 0 1-.772 0L2.5 9.175Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgEmail;
